import React from 'react';
import styled from 'styled-components';
import { _ } from '_locales';

const ErrorTitle = styled.h1`
  font-weight: bold !important;
  font-size: 30px !important;
  margin: 10px;
`;

const ErrorDscr = styled.p`
  font-size: 18px !important;
  margin: 20px;
`;

const ErrorPage = () => (
  <div>
    <ErrorTitle>
      {_('general.server_connection_error')}
    </ErrorTitle>
    <ErrorDscr>
      {_('general.there_is_a_problem_with_getting_data')}
    </ErrorDscr>
  </div>
);

export default ErrorPage;
